import { FunctionComponent, useEffect, useRef } from 'react';

import Title from '@media-ui/core/src/components/Title';
import { useBreakpointsChecker } from '@media-ui/core/src/hooks/useBreakpointsChecker/useBreakpointsChecker';

import classnames from 'classnames';

import NotificationsImage from '../../assets/images/notification.png';
import NotificationsDarkImage from '../../assets/images/notification_dark.png';

import {
  PLACEMENT_DESKTOP_LEFT,
  PLACEMENT_DESKTOP_TOP,
  PLACEMENT_MOBILE_TOP,
} from '../../constants/settings';

import * as s from './PushNotificationsTooltip.css';
import * as T from './PushNotificationsTooltip.types';

const PushNotificationsTooltip: FunctionComponent<
  T.PushNotificationsTooltipProps
> = (props) => {
  const {
    config = {},
    placement,
    customImage,
    classNameImage,
    classNameAction,
    classNameActionInner,
    onCancel,
    onSubscription,
    onMount,
    className,
  } = props;

  const ref = useRef<HTMLDivElement | null>(null);

  const [screen] = useBreakpointsChecker();

  useEffect(() => {
    if (typeof onMount === 'function') {
      onMount(ref.current);
    }
  }, [onMount]);

  const setStyle = () => {
    return screen.isTouch
      ? {
          top: `${placement?.mobile?.top || PLACEMENT_MOBILE_TOP}px`,
        }
      : {
          top: `${placement?.desktop?.top || PLACEMENT_DESKTOP_TOP}px`,
          left: `${placement?.desktop?.left || PLACEMENT_DESKTOP_LEFT}px`,
        };
  };

  const {
    title = 'Будьте в курсе — подпишитесь на уведомления',
    subscriptionButtonText = 'Подписаться',
    cancelButtonText = 'Нет, спасибо',
  } = config;

  const renderImage = () => {
    return customImage ? (
      <div className={classnames(s.wrapperImage, classNameImage)}>
        {customImage}
      </div>
    ) : (
      <picture className={classnames(s.wrapperImage, classNameImage)}>
        <source
          srcSet={NotificationsDarkImage}
          media="(prefers-color-scheme: dark) and (max-width: 659px)"
        />
        <source
          srcSet={NotificationsImage}
          media="(prefers-color-scheme: light), (prefers-color-scheme: no-preference)"
        />
        <img className={s.image} src={NotificationsImage} />
      </picture>
    );
  };

  return (
    <div ref={ref} className={classnames(s.root, className)} style={setStyle()}>
      <div className={classnames(s.action, classNameAction)}>
        <div className={classnames(s.actionInner, classNameActionInner)}>
          <Title level="3" semantic={false} className={s.header}>
            {title}
          </Title>
          <div className={s.buttons}>
            <button
              data-logger="PushSubscribeButton"
              onClick={onSubscription}
              className={classnames(s.button, s.subscriptionButton)}
            >
              {subscriptionButtonText}
            </button>
            <button
              data-logger="PushSubscribeLater"
              onClick={onCancel}
              className={classnames(s.button, s.cancelButton)}
            >
              {cancelButtonText}
            </button>
          </div>
        </div>
        {renderImage()}
      </div>
    </div>
  );
};

export default PushNotificationsTooltip;
